import { useCallback } from "react";

export const useReplaceEmoji = () => {
 const replace = useCallback((string) => {
    if (!string) return "";

    return string.replace(/{{(.*?)}}/g, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    );
  }, []);


  return replace;
};
